module.exports = __webpack_public_path__ + "media/application/images/ui/filter-sort-4b6b2d097ba6005716222839b3cc471e.svg";